// Informations.js
import React from 'react';
import AboutMe from '../components/aboutme';
import '../assets/style/Informations.css';

const Informations = () => {
  return (
    <div className="sections">
      <AboutMe />
    </div>
  );
}

export default Informations;
